import { toast } from "react-toastify";

import {
  addInvioceChargesFailure,
  addInvioceChargesNoteFailure,
  addInvoiceChargesNoteStart,
  addInvoiceChargesNoteSuccess,
  addInvoiceChargesStart,
  addInvoiceChargesSuccess,
  deleteInvoiceChargesFailure,
  deleteInvoiceChargesStart,
  deleteInvoiceChargesSuccess,
  editInvoiceChargesFailure,
  editInvoiceChargesStart,
  editInvoiceChargesSuccess,
  fetchInvioceChargesStart,
  fetchInvoiceChargesFailure,
  fetchInvoiceChargesPDFFailure,
  fetchInvoiceChargesPDFSuccess,
  fetchInvoiceChargesSuccess,
  getChargesBillByIdFailure,
  getChargesBillByIdStart,
  getChargesBillByIdSuccess,
} from "./reducer";
import {
  addInvioceChargesService,
  deleteInvoiceChargesService,
  editChargesNoteService,
  editInvoiceChargesService,
  getBillInvioiceChargesPDFService,
  getChargesBillIdService,
  getInvioiceChargesService,
} from "../../Services/InvoiceChargesService";

//thunk for fetch the category list
export const fetchInvoiceChargesList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchInvioceChargesStart());
      const response = await getInvioiceChargesService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchInvoiceChargesSuccess({
            invoiceCharges: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchInvoiceChargesSuccess({
            invoiceCharges: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchInvoiceChargesFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchInvoiceChargesFailure(error));
    }
  };

//thunk for the addig the category

export const addInvioceCharges = (requestParam) => async (dispatch) => {
  try {
    dispatch(addInvoiceChargesStart());

    const response = await addInvioceChargesService(requestParam);

    if (response) {
      toast.success(response.message);
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = response?.headers["filename"];
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      dispatch(addInvoiceChargesSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addInvioceChargesFailure("Failed to book trip"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addInvioceChargesFailure(error));
  }
};

// // // //this is the thunk for delete the category
export const deleteInvoiceCharges = (invoiceId) => async (dispatch) => {
  try {
    dispatch(deleteInvoiceChargesStart());

    const response = await deleteInvoiceChargesService(invoiceId);
    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteInvoiceChargesSuccess(invoiceId));
    } else {
      toast.error("Failed to delete Booked Trip");
      dispatch(deleteInvoiceChargesFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteInvoiceChargesFailure(error));
  }
};

// // //this tunk for the edit meal category
export const editInvoiceCharges = (id, requestParam) => async (dispatch) => {
  try {
    dispatch(editInvoiceChargesStart());

    const response = await editInvoiceChargesService(id, requestParam);

    if (response) {
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = response?.headers["filename"];
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      toast.success(response.message);
      dispatch(editInvoiceChargesSuccess(response));
    } else {
      dispatch(editInvoiceChargesFailure("Failed to update Booked Trip"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editInvoiceChargesFailure(error));
  }
};

//this thunk is for the get by id
export const fetchChargesBillById = (id) => async (dispatch) => {
  try {
    dispatch(getChargesBillByIdStart());
    const response = await getChargesBillIdService(id);
    if (response?.data) {
      dispatch(getChargesBillByIdSuccess(response.data));
    } else {
      dispatch(getChargesBillByIdFailure("No category found"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(getChargesBillByIdFailure(error));
  }
};

export const fetchBillChargesInvoicePDF = (id) => async (dispatch) => {
  try {
    const response = await getBillInvioiceChargesPDFService(id);
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = response?.headers["filename"];
    // `BillInvoice_${id}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    dispatch(fetchInvoiceChargesPDFSuccess());
  } catch (error) {
    dispatch(fetchInvoiceChargesPDFFailure(error));
  }
};

export const updateChargesNote = (id, requestParam) => async (dispatch) => {
  try {
    dispatch(addInvoiceChargesNoteStart());
    const response = await editChargesNoteService(id, requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addInvoiceChargesNoteSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addInvioceChargesNoteFailure("Failed to add Note"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addInvioceChargesNoteFailure(error));
  }
};
